export let goodsTypes = {
  'OPERATING_EVENT': '运营活动',
  'REGISTRATION': '预约报名'
}
